/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.purchase.options.rpc.PurchaseOptionsService
 */

export const findAllPurchasableProductsRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findAllPurchasableProducts',
  auth: 'app',
  fingerprint: 'Okr-0_i-sWaQw5mnJg9QhOqDBJXDb_F_'
};
export const findPurchaseOptionsRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findPurchaseOptions',
  auth: 'app',
  fingerprint: 'jwMERImAG1avxCb5hHhOOeqDBJXDb_F_'
};
export const findPurchaseRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findPurchase',
  auth: 'app',
  fingerprint: '6Ii_vtv0RPEtngO5xAviIOqDBJXDb_F_'
};
export const findPackagedQuantityPurchaseOptionsRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findPackagedQuantityPurchaseOptions',
  auth: 'app',
  fingerprint: 'yTPvAtxH1Douo8espUIC4-qDBJXDb_F_'
};
export const findQuantityPackPricingTiersRpc = {
  serviceName: 'com.hubspot.purchase.options.rpc.PurchaseOptionsService',
  rpcName: 'findQuantityPackPricingTiers',
  auth: 'app',
  fingerprint: 'dx8N7vUCMYA05qP2vTYNNOqDBJXDb_F_'
};